export const getParam = (name) => {
  // eslint-disable-next-line no-restricted-globals
  var param = decodeURI((RegExp(name + '=' + '(.+?)(&|$)').exec(location.search) || [null])[1]);
  return param == 'undefined' ? undefined : param;
};
